import { useGetApiV1CourseregistrationDocumentCourseregistrationidAttachments } from '@/shared/api/generated';

import type { EnrollmentDocument } from '../types/enrollment';
import { attachmentGroupsToDocuments } from './useEnrollmentDetail';

/**
 * Hook para carregar os documentos exigidos de uma matrícula.
 *
 * Encapsula `GET /api/v1/courseregistration/document/{courseRegistrationId}/attachments`
 * e converte a resposta para {@link EnrollmentDocument[]}.
 *
 * @param enrollmentId - ID da matrícula (courseRegistrationId)
 * @returns Lista de documentos com estado de loading e refetch
 *
 * @example
 * ```tsx
 * const { documents, isLoading, isRefetching, refetch } = useEnrollmentDocuments(enrollmentId);
 * ```
 */
export function useEnrollmentDocuments(enrollmentId: number) {
  const { data, isLoading, isRefetching, refetch } =
    useGetApiV1CourseregistrationDocumentCourseregistrationidAttachments(enrollmentId);

  const documents: readonly EnrollmentDocument[] = attachmentGroupsToDocuments(data ?? []);

  return { documents, isLoading, isRefetching, refetch } as const;
}
